const isMobileViewport = () => {
  const mainLinksDropdown = document.querySelector('#mainLinksDropdown')
  return !!mainLinksDropdown && getComputedStyle(mainLinksDropdown).display !== 'none'
}

const isHidden = (el) =>
  el.style.display === 'none' || getComputedStyle(el).display === 'none'

const slideDown = (el) => {
  if (!isHidden(el)) return

  el.style.display = 'block'
  el.style.height = '0px'

  const height = el.scrollHeight

  requestAnimationFrame(() => {
    el.style.height = `${height}px`
  })

  el.addEventListener(
    'transitionend',
    () => {
      el.style.removeProperty('height')
    },
    { once: true },
  )
}

const slideUp = (el) => {
  if (isHidden(el)) return

  el.style.height = `${el.scrollHeight}px`

  requestAnimationFrame(() => {
    el.style.height = '0px'
  })

  el.addEventListener(
    'transitionend',
    () => {
      el.style.display = 'none'
      el.style.removeProperty('height')
    },
    { once: true },
  )
}

const slideToggle = (el) => (isHidden(el) ? slideDown(el) : slideUp(el))

const siblingsOf = (el, selector) =>
  Array.from(el.parentElement.children).filter(
    (sibling) => sibling !== el && (!selector || sibling.matches(selector)),
  )

const closeCollapseOnOutsideClick = (collapseSelector, toggleSelector) => {
  document.addEventListener('click', (e) => {

    const collapseEl = document.querySelector(collapseSelector)
    if (!collapseEl || !collapseEl.classList.contains('show')) return
    if (e.target.closest(collapseSelector) || e.target.closest(toggleSelector)) return

    document.querySelector(toggleSelector).click()
  })
}

window.addEventListener('DOMContentLoaded', () => {
  if (!document.querySelector('.profile')) return

  const activeItem = document.querySelector('.profileNav_activeItem')
  if (!activeItem) return

  const activeLinkItem = activeItem.querySelector('.profileNav_itemName')
  const activeSubLinksList = activeItem.querySelector(
    '.profileNav_subItemsList',
  )
  const activeSubLinks = Array.from(
    activeItem.querySelectorAll('.profileNav_subLink'),
  )

  // Set active profile item
  if (!activeItem.classList.contains('hasSubmenu')) {
    activeItem.classList.add('active')
  }

  // Set active link text for profile main links dropdown on mobile
  const mainLinksDropdown = document.querySelector('#mainLinksDropdown')
  if (mainLinksDropdown && activeLinkItem) {
    mainLinksDropdown.textContent = activeLinkItem.textContent
  }

  // Close the main links dropdown on click outside of it (mobile only)
  closeCollapseOnOutsideClick('#mainLinksList', '#mainLinksDropdown')

  if (activeSubLinksList) {
    let activeSubLink = activeSubLinks[0]
    let hash = window.location.hash

    const setActiveLink = () => {
      if (!hash) return

      activeSubLinks.forEach((link) => {
        if (link.hash === hash) {
          activeSubLinks.forEach((l) => l.classList.remove('active'))
          link.classList.add('active')
          activeSubLink = link
        }
      })
    }

    setActiveLink()

    document.querySelector('.profileNav').insertAdjacentHTML(
      'beforeend',
      `<div class="profileNav_subLinksDropdown" id="subLinksDropdown">
        <a id="subLinksDropdownTitle"
           class="profileNav_subLinksDropdownTitle"
           data-bs-toggle="collapse"
           href="#subLinkList"
           aria-expanded="false"
           aria-controls="subLinkList">${activeSubLink.textContent}</a>
        <ul class="profileNav_subLinkList collapse" id="subLinkList">${activeSubLinksList.innerHTML}</ul>
      </div>`,
    )

    const subLinksDropdownTitle = document.querySelector(
      '#subLinksDropdownTitle',
    )

    window.addEventListener('hashchange', () => {
      hash = window.location.hash
      setActiveLink()
      subLinksDropdownTitle.textContent = activeSubLink.textContent
    })

    closeCollapseOnOutsideClick('#subLinkList', '#subLinksDropdownTitle')

    document.addEventListener('click', (e) => {
      if (!e.target.closest('#subLinkList .profileNav_subLink')) return

      const subLinkList = document.querySelector('#subLinkList')
      if (!subLinkList || !subLinkList.classList.contains('show')) return

      subLinksDropdownTitle.click()
    })
  }

  document
    .querySelectorAll('.profileNav_item.hasSubmenu .profileNav_itemName')
    .forEach((itemName) => {
      itemName.addEventListener('click', (e) => {
        if (!isMobileViewport()) {
          e.preventDefault()
        }

        const item = e.currentTarget
        const parent = item.parentElement

        parent.classList.toggle('active')

        siblingsOf(item, '.profileNav_subItemsList').forEach(slideToggle)

        siblingsOf(parent).forEach((siblingItem) => {
          Array.from(siblingItem.children)
            .filter((child) => child.matches('.profileNav_subItemsList'))
            .forEach(slideUp)
        })

        siblingsOf(parent, '.hasSubmenu.active').forEach((siblingItem) => {
          siblingItem.classList.remove('active')
        })
      })
    })
})
